/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Sandy_Fox_MeltInputs */

const en_full_sandy_fox_melt = /** @type {(inputs: Full_Sandy_Fox_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

const de_full_sandy_fox_melt = /** @type {(inputs: Full_Sandy_Fox_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaktiv`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Full_Sandy_Fox_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_sandy_fox_melt = /** @type {((inputs?: Full_Sandy_Fox_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Sandy_Fox_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_sandy_fox_melt(inputs)
	return de_full_sandy_fox_melt(inputs)
});